<template>
    <div class="container">
        <div class="head">
            <maijia-head></maijia-head>
        </div>
        <div class="content">
            <div class="content_left">
                <p class="title">{{ title }}</p>
                <div class="detail">
                    <div v-html="content" class="news_detail"></div>
                </div>
            </div>
            <div class="content_right">
                <div class="contact">
                    <p class="c_000" style="font-size: 16px;">{{$t('maijia.DuoMaiTitle')}}</p>
                    <p class="c_666" style="font-size: 14px;padding:10px 0 20px;">{{$t('maijia.DuoMaiIllustrate')}}</p>
                    <div class="line"></div>
                    <p class="c_000" style="font-size: 16px;padding:22px 0 10px;">{{$t('maijia.contactTitle')}}</p>
                    <p class="c_666" style="font-size:14px;word-break:normal;">
                        {{$t('maijia.contactText1')}}<br />
                        {{$t('maijia.contactText2')}}<br />
                        <template v-if="$i18n.locale=='zh'">
                            {{$t('maijia.contactText3')}}<br />
                        </template>
                        {{$t('maijia.contactText4')}}<br />
                        {{$t('maijia.contactText5')}}<br />
                    </p>
                    <input type="text" style="margin:14px 0 10px;" v-model="name" :placeholder="placeholderName">
                    <input type="text" v-model="contactWay" :placeholder="placeholderContactWay">
                    <div class="submit" @click="handleSubmit">{{$t('maijia.submitBtn')}}</div>
                </div>
                <div class="qrcode">
                    <p class="c_000">{{$t('maijia.contactText6')}}</p>
                    <img src="../assets/images/erweima.png" alt="">
                </div>
            </div>
        </div>
        <foot-cpright></foot-cpright>
    </div>
</template>

<script>
import maijiaHead from '../components/maijia-head.vue'
import footCpright from '../components/foot-cpright.vue'
export default {
    data() {
        return {
            content: "",
            title: "",
            name: '',
            contactWay: '',
            placeholderName: '',
            placeholderContactWay: '',
        }
    },
    components: {
        maijiaHead,
        footCpright,
    },
    computed: {
        lang() {
            return this.$i18n.locale
        }
    },
    watch: {
        'lang'() {
            this.handleLangChange()
        }
    },
    created() {
        this.handleLangChange()
    },
    methods: {
        handleLangChange() {
            if (this.$i18n.locale == 'en') {
                this.placeholderName = 'your name'
                this.placeholderContactWay = 'contact information'
            } else {
                this.placeholderName = '您的姓名'
                this.placeholderContactWay = '您的联系方式'
            }
            this.$http
                .get("site/news-detail", {
                    params: {
                        NewsID: this.$route.query.NewsID,
                        lang: this.$i18n.locale
                    }
                })
                .then(response => {
                    this.content = response.d["Content"];
                    this.title = response.d["Title"];
                });
        },
        handleSubmit() {
            const { name, contactWay } = this
            if (!name || !contactWay) {
                return false
            }
            this.$http
                .get("site/mplus-customer", {
                    params: {
                        Name: name,
                        Email: contactWay
                    }
                })
                .then(response => {
                    if (response.f > 0) {
                        this.$message.success('提交成功！')
                    } else {
                        this.$message.error(response.m)
                    }
                });
        }
    }
}
</script>

<style lang="scss" scoped>
.c_000 {
    color: #000;
}
.c_666 {
    color: #666666;
}

.container {
    background-color: #fff;
}
.head {
    background-color: #000;
}
.content {
    width: 1200px;
    min-height: 841px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.content_left {
    width: 857px;
    height: 100%;
}

.title {
    font-size: 26px;
    color: #000000;
    text-align: center;
    line-height: 37px;
    padding: 60px 0 40px;
}
.news_detail {
    width: 100%;
    padding-bottom: 20px;
    & /deep/ p {
        clear: both;
        font-size: 16px;
        color: #000000;
        line-height: 32px;
        & img {
            width: 100%;
            display: inline-block;
        }
    }
    & /deep/ img {
        width: 100%;
        display: inline-block;
    }
}

.content_right {
    padding-top: 137px;
    width: 302px;
}

.contact {
    width: 100%;
    // height: 455px;
    border: 1px solid #eeeeee;
    margin-bottom: 10px;
    padding: 20px 18px;
    & > .line {
        width: 268px;
        height: 1px;
        background: #eeeeee;
    }
    & > input {
        width: 246px;
        height: 46px;
        background: #ebebeb;
        border-radius: 4px;
        border: none;
        font-size: 18px;
        color: #999999;
        font-size: 14px;
        padding-left: 18px;
    }
    & > input:focus {
        border: 1px solid #ff6d27;
        background: #ffffff;
        color: #000000;
    }

    & > .submit {
        width: 246px;
        height: 46px;
        text-align: center;
        line-height: 46px;
        background: #ff6d27;
        font-size: 16px;
        color: #ffffff;
        margin-top: 20px;
    }
}

.qrcode {
    height: 228px;
    border: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    & > p {
        font-size: 16px;
        padding-bottom: 10px;
    }
    & > img {
        width: 156px;
        height: 156px;
    }
}
</style>